import { CircularProgress, Stack, Typography } from "@mui/material";
import { FC } from "react";

export const AuthLoadingScreen: FC = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100vh" gap={2}>
      <CircularProgress />
      <Typography>ログイン中...</Typography>
    </Stack>
  );
};
